// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_MEg","cls2":"ClaimEvaluationRow-cls2_XIe ClaimEvaluationRow-cls1_MEg"};